// extracted by mini-css-extract-plugin
export default {"workshopInput":"AtHt6_workshopInput__WxU8A","workshops":"AtHt6_workshops__Qt-nZ"};